import { render, staticRenderFns } from "./directorSignup.vue?vue&type=template&id=52db6b08&"
import script from "./directorSignup.vue?vue&type=script&lang=js&"
export * from "./directorSignup.vue?vue&type=script&lang=js&"
import style0 from "./directorSignup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports